import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from '@app/shared/shared.module';

import { EditReportComponent } from './edit-report/edit-report.component';
import { SettingsFilterComponent } from './settings-filter/settings-filter.component';

// Third Party
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { /*BsDatepickerModule, */BsDropdownModule/*, TooltipModule, AccordionModule, ModalModule, TabsModule */} from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    SharedModule,
    BsDatepickerModule, BsDropdownModule
  ],
  declarations: [
    EditReportComponent,
    SettingsFilterComponent,
  ],
  exports: [
    EditReportComponent,
    SettingsFilterComponent,
  ]
})
export class ReportFilterModule { }
